import React from "react";
import { useWindowSize } from "@react-hook/window-size";
import { Link } from "@reach/router";

import textureBG from "../assets/img/jep-bg.png";
import splashBGHorizontal from "../assets/img/jep-bg-characters.png";
import splashBGVertical from "../assets/img/homescreen-portrait.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const Splash = () => {
	const [width, height] = useWindowSize();

	return (
		<div>
			{/* background texture */}
			<div
				css={css`
					position: absolute;
					background-image: url(${textureBG});
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
					width: 100%;
					height: 100%;
				`}
			/>
			{/* splash image (changes orientation with screen size) */}
			<div
				css={css`
					position: absolute;
					background-image: url(${width / height >= 1 ? splashBGHorizontal : splashBGVertical});
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
					width: 100%;
					height: 100%;
				`}
			/>
			{/* actions */}
			{width / height >= 1 && (
				<div
					css={css`
						display: flex;
						justify-content: center;

						position: absolute;
						width: 100%;
						height: 100%;
					`}
				>
					<div
						css={css`
							display: flex;
							justify-content: flex-end;
							flex-direction: column;
							text-align: center;

							max-width: 200px;
						`}
					>
						{/* start button */}
						<Link to="/play/Brain_Trivia/play">
							<button
								type="button"
								css={css`
									display: flex;
									justify-content: center;
									align-items: center;

									color: white;
									font-weight: bold;
									font-size: 3rem;

									background-color: #dc4e39;
									border: none;
									border-radius: 6px;

									padding: 10px;
									margin-bottom: 20px;
								`}
							>
								START
							</button>
						</Link>
						{/* how to play button */}
						<Link to="/play/Brain_Trivia/how-to-play">
							<button
								type="button"
								css={css`
									color: white;

									background-color: transparent;
									border: none;

									margin-bottom: 30px;
								`}
							>
								HOW TO PLAY <FontAwesomeIcon icon={faQuestionCircle} />
							</button>
						</Link>
					</div>
				</div>
			)}
		</div>
	);
};

export default Splash;
